export default {"src":"/_next/static/media/scope_logo_rgb_scope_green.0db162fd.svg","height":71,"width":304,"blurWidth":0,"blurHeight":0};